export default __webpack_public_path__ + "static/media/cafe.31e89b50.jpeg";